import "../../styles/strategiesInfo.css";

export default function MatchStatsDetailsInfo({ onClose }) {
  return (
    <div className="info-backdrop" onClick={onClose}>
      <div className="info-modal" onClick={e => e.stopPropagation()}>

        <button className="info-close" onClick={onClose}>✕</button>

        <h2>Meccs statisztikák értelmezése</h2>

        <p className="info-lead">
          Ezen az oldalon az adott mérkőzéshez kapcsolódó statisztikákat látod,
          amelyek segítenek reális képet alkotni a csapatok teljesítményéről
          és egymáshoz viszonyított erőviszonyairól.
        </p>

        <ul className="info-list">
          <li>
            📊 <strong>Kétcsapatos statisztikák</strong> – Az olyan adatok,
            ahol mindkét csapat szerepel (pl. lövések, labdabirtoklás),
            közvetlen összehasonlításra szolgálnak.
          </li>

          {/* <li>
            🧩 <strong>Egycsapatos mutatók</strong> – Bizonyos statisztikák
            csak az egyik félre vonatkoznak (pl. sorozatok, átlagértékek),
            ezek önálló kontextusban értelmezendők.
          </li> */}

          <li>
            🕒 <strong>Időszak alapú adatok</strong> – Egyes értékek
            teljes szezon, utolsó X meccs vagy aktuális forma alapján
            készülnek – mindig vedd figyelembe az időtávot.
          </li>

          <li>
            ⚖️ <strong>Arányok, nem végkimenetel</strong> – A statisztikák
            nem garantálnak eredményt, hanem tendenciákat mutatnak,
            amelyek segítik a döntésedet.
          </li>
        </ul>

        <p className="info-footnote">
          💡 Tipp: A legerősebb következtetések akkor születnek,
          ha több statisztikát együtt vizsgálsz, és nem egyetlen
          kiugró adat alapján döntesz.
        </p>

      </div>
    </div>
  );
}